import { useState } from "react";
import { Play } from "lucide-react";

const TITEL = "In diesen 5 Video-Minuten zeige ich Ihnen, wie wir für Fonds, Kapitalgeber, Nischen-Industrie und spezialisierte Beratungen jeden Monat den Kalender mit Entscheiderterminen füllen.";

export default function VideoFassade() {
  const [aktiv, setAktiv] = useState(false);
  const [hinweis, setHinweis] = useState(false);
  const url = process.env.REACT_APP_VIMEO_URL;

  if (aktiv && url) {
    const src = url.includes("?") ? `${url}&autoplay=1` : `${url}?autoplay=1`;
    return (
      <div className="aspect-video w-full overflow-hidden rounded-[2px] border border-navy/15 bg-navy" data-testid="hero-video-aktiv">
        <iframe
          src={src}
          className="h-full w-full"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          title={TITEL}
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div
      className="relative aspect-video w-full overflow-hidden rounded-[2px] border border-navy/15"
      data-testid="hero-video-vorschau"
      style={{ background: "radial-gradient(600px 300px at 50% 0%, #3C679C, #2B5A92 72%)" }}
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
        <button
          type="button"
          data-testid="hero-video-play"
          aria-label="Video abspielen"
          onClick={() => (url ? setAktiv(true) : setHinweis(true))}
          className="flex h-16 w-16 items-center justify-center rounded-full border border-white/40 bg-white/10 text-white backdrop-blur-sm transition-all duration-300 hover:scale-105 hover:border-gruenhover hover:bg-gruen"
        >
          <Play size={22} fill="currentColor" strokeWidth={0} />
        </button>
        {hinweis && !url && (
          <p className="text-sm text-hellblau" data-testid="hero-video-hinweis">Das Video wird eingebunden, sobald der Vimeo-Link hinterlegt ist.</p>
        )}
      </div>
    </div>
  );
}
